import React, { Component, useEffect, useState } from "react";

// table(components)
import filterFactory, { textFilter } from "react-bootstrap-table2-filter";
import BoostrapTable from "react-bootstrap-table-next";
import paginationFactory from "react-bootstrap-table2-paginator";
import { PageOptions } from "../../components/PageParams";
import axios from "axios";
import { useDispatch, useSelector } from "react-redux";
import { setReminder } from "../../../features/UserActions";
import { HttpJsonHeader } from "../../../features/Environments";
import BranchPricelistPopup from "./BranchPricelistPopup";
import BranchPricelistEditor from "./BranchPricelistEditor";
import { Button, OverlayTrigger, Tooltip } from "react-bootstrap";
import {
  AiOutlinePlus,
  AiFillEdit,
  AiOutlineDelete,
  AiOutlineControl,
} from "react-icons/ai";
import ConfirmDialog, { GetConfirmTitle } from "../../components/ConfirmDialog";
import styled from "styled-components";
import { ThaiDate } from "../../../core/ThaiDate";

export default function BranchPricelist(props) {
  // ** UserInfo + Popup Message ***/
  const formName = "ตารางราคาค่าตรวจ";
  const userDetail = useSelector((state) => state.user.detail);
  const dispatch = useDispatch();
  // ** Main State ***/
  const [priceEditor, setPriceEditor] = useState({ show: false, action: null });
  const [editor, setEditor] = useState({ show: false, action: null });
  const [data, setData] = useState([]);
  const [dataX, setDataX] = useState([]);
  const [selectedRow, setSelectedRow] = useState(null);
  const [showConfirm, setShowConfirm] = useState(false);
  const [confirmAction, setConfirmAction] = useState(null);
  const [updateFlag, setUpdateFlag] = useState(true);

  //if(winState == null) setWinState({show:false, setWinState:null});
  useEffect(() => {
    if (updateFlag) {
      getData();
      setUpdateFlag(false);
    }
  }, [updateFlag]);

  useEffect(() => {
    getDataX();
  }, []);
  //----------------------------------------------------------------------
  // ** List All rows
  const getData = async () => {
    await axios
      .post(
        process.env.REACT_APP_API + "api/pricelist/list-data",
        {
          UserInfo: userDetail,
          SearchTxt: "",
        },
        HttpJsonHeader
      )
      .then((res) => {
        setData(res.data && res.data.rows);
      })
      .catch((err) =>
        dispatch(
          setReminder({ show: true, message: err.message, type: "error" })
        )
      );
  };
  //----------------------------------------------------------------------
  //Get component for selection on editting window
  const getDataX = async () => {
    await axios
      .post(
        process.env.REACT_APP_API + "api/pricelist/select-component",
        {
          UserInfo: userDetail,
        },
        HttpJsonHeader
      )
      .then((res) => {
        setDataX(res.data);
      })
      .catch((err) => dispatch(setReminder({ show: true, message: err })));
  };
  //----------------------------------------------------------------------
  // Actions
  // Save new Action
  const editPriceAction = (data) => {
    setSelectedRow({
      row: data,
      action: () => {
        setPriceEditor({
          show: true,
          action: null,
        });
      },
    });
  };

  const openAction = () => {
    setEditor({ show: true, action: null });
  };
  const actionNewData = () => {
    setSelectedRow({
      row: { price_list_id: 0 },
      action: openAction,
    });
  };
  // Update Action
  const actionUpdate = (data) => {
    setSelectedRow({
      row: data,
      action: openAction,
    });
  };
  // Delete Action
  const actionDelete = (row) => {
    setShowConfirm(true);
    setConfirmAction({
      title: GetConfirmTitle("DELETE"),
      data: row,
      action: (row) => {
        axios
          .post(
            process.env.REACT_APP_API + "api/pricelist/delete",
            {
              ItemInfo: row,
              UserInfo: userDetail,
            },
            HttpJsonHeader
          )
          .then((res) => {
            setUpdateFlag(true);
            dispatch(
              setReminder({
                show: true,
                message: "ยกเลิกสมบูรณ์",
                type: "success",
              })
            );
          })
          .catch((err) => {
            dispatch(
              setReminder({ show: true, message: err.message, type: "error" })
            );
          });
      },
    });
  };
  //-----------------------------------f-----------------------------------
  //columns
  const getHeaderStyle = (wi) => {
    return {
      width: wi,
      background: "var(--table-header-back-color)",
    };
  };
  const customTextFilter = {
    placeholder: "...",
  };
  const formatEditBox = (x, row) => {
    return (
      <div>
        <OverlayTrigger
          placement="top"
          overlay={(props) => <Tooltip {...props}>แก้ไข</Tooltip>}
        >
          <Button
            variant="info"
            className="info-button"
            onClick={() => actionUpdate(row)}
          >
            <AiFillEdit />
          </Button>
        </OverlayTrigger>

        <OverlayTrigger
          placement="bottom"
          overlay={(props) => <Tooltip {...props}>รายละเอียดราคา</Tooltip>}
        >
          <Button
            variant="success"
            className="info-button"
            onClick={() => {
              editPriceAction(row);
            }}
          >
            <AiOutlineControl />
          </Button>
        </OverlayTrigger>

        <OverlayTrigger
          placement="top"
          overlay={(props) => <Tooltip {...props}>ลบ</Tooltip>}
        >
          <Button
            variant="danger"
            className="info-button"
            onClick={() => {
              actionDelete(row);
            }}
          >
            <AiOutlineDelete />
          </Button>
        </OverlayTrigger>
      </div>
    );
  };
  //----------------------------------------------------------------------
  const getDateFormat = (cell, row) => {
    return <ThaiDate dateValue={cell} />;
  };
  //----------------------------------------------------------------------
  const columns = [
    {
      dataField: "docu_no",
      text: "เลขที่เอกสาร",
      sort: true,
      headerStyle: () => getHeaderStyle("150px"),
      style: {
        border: "none",
        color: "var(--table-text-color)",
        textAlign: "left",
        paddingLeft: "20px",
      },
      filter: textFilter(customTextFilter),
    },
    {
      dataField: "docu_date",
      text: "วันที่",
      sort: true,
      headerStyle: () => getHeaderStyle("120px"),
      style: {
        border: "none",
        color: "var(--table-text-color)",
        textAlign: "center",
      },
      filter: textFilter(customTextFilter),
      formatter: getDateFormat,
    },
    {
      dataField: "cust_name",
      text: "ลูกค้า",
      sort: true,
      headerStyle: () => getHeaderStyle("auto"),
      style: {
        border: "none",
        color: "var(--table-text-color)",
        textAlign: "left",
        paddingLeft: "10px",
      },
      filter: textFilter(customTextFilter),
    },
    {
      dataField: "descript",
      text: "ชื่อใช้งาน",
      sort: true,
      headerStyle: () => getHeaderStyle("auto"),
      style: {
        border: "none",
        color: "var(--table-text-color)",
        textAlign: "left",
        paddingLeft: "10px",
      },
      filter: textFilter(customTextFilter),
    },
    {
      dataField: "contract_no",
      text: "เลขที่เอกสาร",
      sort: true,
      headerStyle: () => getHeaderStyle("200px"),
      style: {
        border: "none",
        color: "var(--table-text-color)",
        textAlign: "left",
        paddingLeft: "10px",
      },
      filter: textFilter(customTextFilter),
    },
    {
      dataField: "begin_date",
      text: "เริ่ม",
      sort: true,
      headerStyle: () => getHeaderStyle("120px"),
      style: {
        border: "none",
        color: "var(--table-text-color)",
        textAlign: "center",
      },
      filter: textFilter(customTextFilter),
      formatter: getDateFormat,
    },
    {
      dataField: "end_date",
      text: "สิ้นสุด",
      sort: true,
      headerStyle: () => getHeaderStyle("120px"),
      style: {
        border: "none",
        color: "var(--table-text-color)",
        textAlign: "center",
      },
      filter: textFilter(customTextFilter),
      formatter: getDateFormat,
    },
    {
      dataField: "box",
      text: "-",
      headerStyle: () => getHeaderStyle("150px"),
      style: {
        border: "none",
        color: "var(--table-text-color)",
        textAlign: "center",
      },
      formatter: formatEditBox,
    },
  ];
  //----------------------------------------------------------------------
  return (
    <div>
      <HBox>
        <OverlayTrigger
          placement="top"
          overlay={(props) => <Tooltip {...props}>เพิ่มข้อมูลใหม่</Tooltip>}
        >
          <Button
            variant="primary"
            style={{ margin: "5px" }}
            onClick={() => actionNewData()}
          >
            <AiOutlinePlus /> เพิ่มข้อมูลใหม่
          </Button>
        </OverlayTrigger>
        <div className="table-caption-box-right-flex">{formName}</div>
      </HBox>
      <BoostrapTable
        bootstrap4
        keyField="price_list_id"
        rowClasses={"table-next-rows-style"}
        data={data}
        columns={columns}
        striped
        hover
        condensed
        headerWrapperClasses="headerWrapper"
        wrapperClasses="bs-table-wrapper"
        bordered={true}
        pagination={paginationFactory(PageOptions)}
        filter={filterFactory()}
        // selectRow = {selectRow}
      />
      <BranchPricelistEditor
        {...{
          winState: [editor, setEditor],
          formName,
          selectedRow,
          dataX,
          setDataX,
          setUpdateFlag,
        }}
      ></BranchPricelistEditor>
      <BranchPricelistPopup
        {...{
          winState: [priceEditor, setPriceEditor],
          confirmShow: [showConfirm, setShowConfirm],
          ...{ showConfirm, setShowConfirm, confirmAction, setConfirmAction },
          formName,
          selectedRow,
          dataX,
          setDataX,
          setUpdateFlag,
        }}
      />
      <ConfirmDialog
        {...{ showConfirm, setShowConfirm, confirmAction, setConfirmAction }}
      />
    </div>
  );
}

const HBox = styled.div`
  padding: 0px;
  display: flex;
`;
